var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import Profile from "./ui";
import ErrorComponent from "./ui/atoms/FallbackError";
import DefaultProviders from "./ui/DefaultProviders";
import ErrorBoundary from "./ui/templates/ErrorBoundary";
import IncomeCaptureRoot from "./pages/IncomeCaptureRoot";
var ProfileRoot = function (_a) {
    var config = _a.config, authenticationRedirect = _a.authenticationRedirect;
    return (_jsx(DefaultProviders, __assign({ config: config }, { children: _jsx(ErrorBoundary, __assign({ fallbackComponent: _jsx(ErrorComponent, {}) }, { children: _jsx(Profile, { authenticationRedirect: authenticationRedirect }) })) })));
};
export default ProfileRoot;
export { IncomeCaptureRoot };
